import { apiFetch } from "./api";

const QUEUE = [];
let flushTimer = null;
const MAX_BATCH = 20;

function enqueue(event) {
  QUEUE.push(event);
  if (QUEUE.length >= MAX_BATCH) {
    flushTelemetry();
    return;
  }
  if (!flushTimer) {
    flushTimer = setTimeout(() => {
      flushTimer = null;
      flushTelemetry();
    }, 4000);
  }
}

export async function flushTelemetry() {
  if (!QUEUE.length) return;
  const batch = QUEUE.splice(0, MAX_BATCH);
  try {
    await apiFetch("/telemetry/events", {
      method: "POST",
      body: JSON.stringify({ events: batch }),
    });
  } catch {
    /* dogfood best-effort */
  }
}

export function trackWorkflow(name, meta = {}) {
  enqueue({
    name,
    kind: "workflow",
    route: typeof window !== "undefined" ? window.location.pathname : undefined,
    meta,
  });
}

export function trackClientError(name, meta = {}) {
  enqueue({
    name,
    kind: "client_error",
    route: typeof window !== "undefined" ? window.location.pathname : undefined,
    meta,
  });
}

export function trackWebVital(name, value, meta = {}) {
  enqueue({
    name,
    kind: "web_vital",
    value,
    route: typeof window !== "undefined" ? window.location.pathname : undefined,
    meta,
  });
}

/** Lightweight LCP/CLS without web-vitals package (prod dogfood). */
export function startWebVitalsObserver() {
  if (typeof window === "undefined" || typeof PerformanceObserver === "undefined") return;
  try {
    const po = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.entryType === "largest-contentful-paint") {
          trackWebVital("LCP", entry.startTime, { size: entry.size });
        }
        if (entry.entryType === "layout-shift" && !entry.hadRecentInput) {
          trackWebVital("CLS", entry.value);
        }
      }
    });
    po.observe({ type: "largest-contentful-paint", buffered: true });
    po.observe({ type: "layout-shift", buffered: true });
  } catch {
    /* Safari / unsupported */
  }
  if (typeof document !== "undefined") {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") flushTelemetry();
    });
  }
}
